export function fromJson(json: string): any {
  return JSON.parse(json, (_, v) => {
    if (
      typeof v === 'object' &&
      '$type' in v &&
      '$entries' in v &&
      v['$type'] === 'map'
    ) {
      return new Map(v['$entries']);
    } else {
      return v;
    }
  });
}

export function toJson(value: unknown): string {
  return JSON.stringify(value, (_, v) => {
    if (v instanceof Map) {
      return {$type: 'map', $entries: [...v.entries()]};
    } else {
      return v;
    }
  });
}
